import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

import authReducer from "../slice/authSlice";
import organizationReducer from "../slice/organizationSlice";
import userReducer from "../slice/userSlice";
import subscriptionReducer from "../slice/subscriptionSlice";
import notificationReducer from "../slice/notificationSlice";
import layoutReducer from "../slice/layoutSlice";
import selectionReducer from "../slice/selectionSlice";
import { baseApi } from "../api";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    organization: organizationReducer,
    user: userReducer,
    subscription: subscriptionReducer,
    notification: notificationReducer,

    layout: layoutReducer,
    selection: selectionReducer,

    [baseApi.reducerPath]: baseApi.reducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),

  devTools: import.meta.env.MODE !== "production",
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
